import { useTranslation } from 'react-i18next';
import { NewDropdown } from 'app/components/ui';

interface VisibilityProps {
  currentValue: string[];
  onValueChange: (value: string) => void;
}

export const VisibilityPicker = ({ currentValue, onValueChange }: VisibilityProps) => {
  const { t } = useTranslation('tag');

  const visibilityOptions = [
    {
      label: t('visibility.core'),
      value: 'core',
    },
    { label: t('visibility.extension'), value: 'extension' },
  ];

  return <NewDropdown currentValue={currentValue} label={t('visibility.label')} options={visibilityOptions} onUpdate={onValueChange} multiselect={true} />;
};
